














import { Vue, Component } from "vue-property-decorator";
import AssignDataTable from "../../components/DataTables/AssignDataTable.vue";
import CardTitle from "../../components/CardTitle.vue";
import { userUtils } from "../../_utils/userUtils";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import * as auth from "../../_store/auth.module";
import { bus } from "../../main";
import { ArticolazioneInfo } from "../../_models/articolazioneInfo";
import { InstituteInfo } from "../../_models/instituteInfo";
import * as temp from "../../_store/temp.module"

@Component({
  components: {
    AssignDataTable,
    CardTitle
  }
})
export default class AssegnazioneAllieviAziende extends Vue {
  private titleParams: object;
  private dataTableParams: any;
  private richiesteDataTableParams: any;
  private tutorFormDataTableParams: any;
	private createDialogParams: object;
  
  private listaAllievi: any;
  private listaRichiesteAlternanza: any;
  private listaIndirizziStudio: any;
  private counterProvvisori: number;

  constructor() {
    super();
    this.listaAllievi = [];
    this.listaRichiesteAlternanza = [];
    this.listaIndirizziStudio = [];
    this.titleParams = {
      title: "Assegnazione Allievi-Aziende",
      cols: "12",
      sm: "5",
      md: "5",
      lg: "4"
    };
    this.counterProvvisori = 0;
    this.dataTableParams = {
      headers: [
        {
          text: "Allievo",
          value: "allievo"
        },
        {
          text: "Classe Allievo",
          value: "classe"
        },
        {
          text: "Comune Residenza",
          value: "comuneUtente"
        },
        {
          text: "Azienda",
          value: "azienda"
        },
        {
          text: "Tutor Formativo",
          value: "tutorFormativo"
        },
        {
          text: "Status Patto",
          value: "reviewAutorizzazione",
          sortable: false
        },
        {
          text: "Assegna Azienda",
          value: "assignEnterpriseAlternanza",
          sortable: false
        },
        {
          text: "Assegna Tutor Formativo",
          value: "assignTutorFormAlternanza",
          sortable: false
        },
        {
          text: "Dettagli Allievo",
          value: "action",
          sortable: false,
          width: "1%"
        },
        {
          text: "Elimina Associazione",
          value: "eliminaAssociazione",
          sortable: false,
          width: "1%"
        }
      ],
      records: [],
      dialogParams: {
        title: "DETTAGLI UTENTE",
        type: "userTab"
      },
      //filterType: "listaAllievi",
      listaArticolazioni: [
        {
          idArticolazione: "Tutte",
          nomeArticolazione: "Tutte"
        }
      ], activityType: "alternanza"
    };
    this.richiesteDataTableParams = {
      headers: [
        {
          text: "Azienda",
          value: "denominazioneAzienda"
        },
        {
          text: "Luogo Svolgimento",
          value: "comuneTirocinio"
        },
        {
          text: "Nome Tirocinante Indicato",
          value: "nomeTirocinante"
        },
        {
          text: "Cognome Tirocinante Indicato",
          value: "cognomeTirocinante"
        },
        {
          text: "Dettagli Disponibilità",
          value: "details"
        },
        {
          text: "Assegna",
          value: "assignEnterprise"
        }
      ],
      records: [],
      assignmentType: "enterpiseAssignment",
      dialogParams: {
        title: "ELENCO DISPONIBILITA'",
        type: "richiestaAlternanzaTab"
      }
    };
    this.tutorFormDataTableParams = {
      headers: [
        {
          text: "Tutor",
          value: "tutorFormativo"
        },
        {
          text: "Residenza",
          value: "comuneUtente"
        },
        {
          text: "Dettagli Tutor",
          value: "details"
        },
        {
          text: "Assegna",
          value: "assignTutorForm"
        }
      ],
      records: [],
      assignmentType: "tutorFormAssignment",
      dialogParams: {
        title: "ELENCO TUTOR FORMATIVI",
        type: "tutorFormativoTab"
      }
    };
    this.createDialogParams = {
      visible: true,
      type: "nuovoAbbinamentoAlternanza"
    };
  }

  get checkIfDisable() {
    if (this.counterProvvisori === 0) {
      return true;
    } else {
      return false;
    }
  }

  loadStudentsTutor() {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"])
    var counter: number = 0;
    var payload = {
      idIstituto: 0,
      idAnnoScolastico: idAnnoScolastico,
      idTutor: 0
    };
    var instituteInfo = user.readInstituteInfo(this["$store"]);
    var userInfo = user.readUserInfo(this["$store"]);
    payload = {
      idIstituto: instituteInfo.id,
      idAnnoScolastico: idAnnoScolastico,
      idTutor: userInfo.idUtente
    };
    data
      .dispatchStudentsTutor(this["$store"], payload)
      .then(response => {
        this.listaAllievi = response;
        this.dataTableParams.records = response;
        for (let i = 0; i < this.listaAllievi.length; i++) {
          if (this.listaAllievi[i].idStatoAccettazione === 6) {
            counter++;
          }
        }
        this.counterProvvisori = counter;
        bus.$emit("dataLoaded");
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  // loadSectorRequests(indirizziStudioList: any[]) {
  //   var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"])
  //   var payload = {
  //     idIndirizzoStudio: 0,
  //     idAnnoScolastico: idAnnoScolastico,
  //     idIstituto: 0
  //   };
  //   var instituteInfo = user.readInstituteInfo(this["$store"]);
  //   this.listaRichiesteAlternanza = [];
  //   this.richiesteDataTableParams.records = [];
  //   payload.idIstituto = instituteInfo.id;

  //   if (indirizziStudioList.length > 0) {
  //     indirizziStudioList.forEach(item => {
  //       payload.idIndirizzoStudio = item.idIndirizzoStudio;
  //       data
  //         .dispatchRichiesteAlternanzaIndirizzoStudio(this["$store"], payload)
  //         .then(resp => {
  //           resp.forEach(element => {
  //             this.listaRichiesteAlternanza.push(element);
  //             this.richiesteDataTableParams.records.push(element);
  //           });
  //         })
  //         .catch(error => {
  //           if (error.response.status === 403) {
  //             bus.$emit("errorOperation", error.response.statusText);
  //             this["$router"].push("/login");
  //           } else {
  //             bus.$emit("errorOperation", error.response.statusText);
  //           }
  //         });
  //     });
  //   } else {
  //     payload.idIndirizzoStudio = 0;
  //     data
  //       .dispatchRichiesteAlternanzaIndirizzoStudio(this["$store"], payload)
  //       .then(resp => {
  //         resp.forEach(element => {
  //           this.listaRichiesteAlternanza.push(element);
  //           this.richiesteDataTableParams.records.push(element);
  //         });
  //       })
  //       .catch(error => {
  //         if (error.response.status === 403) {
  //           bus.$emit("errorOperation", error.response.statusText);
  //           this["$router"].push("/login");
  //         } else {
  //           bus.$emit("errorOperation", error.response.statusText);
  //         }
  //       });
  //   }
  // }

  loadTutorFormativi() {
    var instituteInfo = user.readInstituteInfo(this["$store"]);
    var payload = {
      idIstituto: instituteInfo.id
    };
    data
      .dispatchTutorFormativi(this["$store"], payload)
      .then(result => {
        this.tutorFormDataTableParams.records = result;
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  created() {
    var token = localStorage.getItem("userToken");
    var parsedToken: any;
    if (token !== null) {
      parsedToken = userUtils.parseToken(token);
    }
    var payload = {
      idUtente: parsedToken.IdUtente,
      tipoSoggetto: parsedToken.IdTipoSoggetto,
      username: parsedToken.Username
    };
    var tempList: any[] = [];
    // var indirizziStudioList: any[] = [];
    user
      .dispatchSetUserInfo(this["$store"], payload)
      .then(() => {
        user
          .dispatchSetInstituteInfo(this["$store"])
          .then(() => {
            data
              .dispatchAssegnazioneArticolazione(
                this["$store"],
                payload.idUtente
              )
              .then(response => {
                response.forEach(element => {
                  this.dataTableParams.listaArticolazioni.push(element);
                });
                data
                  .dispatchIndirizziStudioTutorArticolazione(
                    this["$store"],
                    payload.idUtente
                  )
                  .then(result => {
                    this.listaIndirizziStudio = result;
                    this.loadTutorFormativi();
                    this.loadStudentsTutor();
                    //this.loadSectorRequests(this.listaIndirizziStudio); //non prende la lista corretta perchè il compoennte viene create prima del click
                  })
                  .catch(error => {
                    if (error.response.status === 403) {
                      bus.$emit("errorOperation", error.response.statusText);
                      this["$router"].push("/login");
                    } else {
                      bus.$emit("errorOperation", error.response.statusText);
                    }
                  });
              })
              .catch(error => {
                if (error.response.status === 403) {
                  bus.$emit("errorOperation", error.response.statusText);
                  this["$router"].push("/login");
                } else {
                  bus.$emit("errorOperation", error.response.statusText);
                }
              });
            bus.$emit("loadMenu");
          })
          .catch(() => {
            bus.$emit("stopLoading");
            auth.dispatchLogout(this["$store"]);
            user.dispatchClearState(this["$store"]);
            this["$router"].push("/sessionExpired");
          });
      })
      .catch(() => {
        bus.$emit("stopLoading");
        auth.dispatchLogout(this["$store"]);
        user.dispatchClearState(this["$store"]);
        this["$router"].push("/sessionExpired");
      });

    bus.$on("loadStudentsTutor", () => {
      this.loadStudentsTutor();
    });

    // bus.$on("loadSectorRequests", () => {
    //   this.loadSectorRequests(this.listaIndirizziStudio);
    // });

    bus.$on("filtroAllievi", (filters: any) => {
      const listaAllievi: any = this.listaAllievi;
      var tempList: any = [];
      var tempList2: any = [];
      var tempList3: any = [];
      this.dataTableParams.records = [];
      listaAllievi.forEach((allievo: any) => {
        if (filters.filtroAutorizzazione !== "Tutti") {
          if (filters.filtroAutorizzazione === "Inviati") {
            if (allievo.idStatoDoc === 1) {
              tempList.push(allievo);
            }
          } else if (filters.filtroAutorizzazione === "Eliminati") {
            if (allievo.idStatoDoc === 3) {
              tempList.push(allievo);
            }
          } else if (filters.filtroAutorizzazione === "Confermati") {
            if (allievo.idStatoDoc === 2) {
              tempList.push(allievo);
            }
          }
        } else {
          tempList.push(allievo);
        }
      });
      tempList.forEach((item: any) => {
        if (filters.filtroAnni !== "Tutti") {
          if (filters.filtroAnni === "3") {
            if (item.classe.charAt(0) === "3") {
              tempList2.push(item);
            }
          } else if (filters.filtroAnni === "4") {
            if (item.classe.charAt(0) === "4") {
              tempList2.push(item);
            }
          } else if (filters.filtroAnni === "5") {
            if (item.classe.charAt(0) === "5") {
              tempList2.push(item);
            }
          }
        } else {
          tempList2.push(item);
        }
      });
      tempList2.forEach((item: any) => {
        if (filters.fitroArticolazione !== "Tutte") {
          if (filters.fitroArticolazione === "IT01") {
            if (item.idArticolazione === "IT01") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "IT04") {
            if (item.idArticolazione === "IT04") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "IT05") {
            if (item.idArticolazione === "IT05") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "IT10") {
            if (item.idArticolazione === "IT10") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "IT13") {
            if (item.idArticolazione === "IT13") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "ITAF") {
            if (item.idArticolazione === "ITAF") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "ITEN") {
            if (item.idArticolazione === "ITEN") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "ITET") {
            if (item.idArticolazione === "ITET") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "ITIA") {
            if (item.idArticolazione === "ITIA") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "ITMM") {
            if (item.idArticolazione === "ITMM") {
              tempList3.push(item);
            }
          }
          if (filters.fitroArticolazione === "LI03") {
            if (item.idArticolazione === "LI03") {
              tempList3.push(item);
            }
          }
        } else {
          tempList3.push(item);
        }
      });
      this.dataTableParams.records = tempList3;
    });
  }
}
